import { render, staticRenderFns } from "./IconKoeling.vue?vue&type=template&id=425bc286"
import script from "./IconKoeling.vue?vue&type=script&lang=ts"
export * from "./IconKoeling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports